import React, { createContext, useContext, useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { translations } from '../i18n/translations';

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
  const [lang, setLang] = useState('en');
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname;
    if (path.startsWith('/es')) {
      setLang('es');
    } else if (path.startsWith('/en')) {
      setLang('en');
    }
  }, [location.pathname]);

  const switchLang = (newLang) => {
    localStorage.setItem('preferredLang', newLang);
    setLang(newLang);
    
    // Use replace to prevent cluttering the back button history,
    // and append location.hash to keep the user in the same section of the page.
    navigate(`/${newLang}${location.hash}`, { replace: true });
  };

  const t = translations[lang] || translations.en;

  return (
    <LanguageContext.Provider value={{ lang, switchLang, t }}>
      {children}
    </LanguageContext.Provider>
  );
};

export const useLanguage = () => useContext(LanguageContext);